export default {
  title: "Close without Correction",
  content:
    "<div>This <span class='text-info text-bold'>Issue</span> does not have any " +
    "<span class='text-info text-bold'> accepted Performed Corrective Work</span>. Are you sure you want to close it? <br><br> This " +
    "<span class='text-negative text-uppercase text-bold'>cannot</span> be undone!</div>",
  label: "Reasoning",
}
